document.addEventListener('DOMContentLoaded', () => {
    class TableOfContents {
        constructor() {
            this.headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
            this.tocLinks = document.querySelectorAll('.wp-block-klx-toc a');
            this.initializeObserver();
            this.observeHeadings();
            this.initializeClickHandlers();
            this.checkInitialActiveHeading();
        }

        initializeObserver() {
            this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
                threshold: 0.5,
                rootMargin: '-100px 0px -50% 0px'
            });
        }

        handleIntersection(entries) {
            const hasIntersectingEntry = entries.some(entry => entry.isIntersecting);
            
            entries.forEach(entry => {
                if (!hasIntersectingEntry) return;
                if (!entry.isIntersecting) return;
                
                this.removeActiveClasses();
                this.activateCorrespondingLink(entry.target);
            });
        }

        removeActiveClasses() {
            this.tocLinks.forEach(link => {
                link.parentElement.classList.remove('active');
            });
        }

        activateCorrespondingLink(heading) {
            const id = this.getHeadingId(heading);
            if (!id) return;

            const correspondingLink = document.querySelector(`.wp-block-klx-toc a[href="#${id}"]`);
            if (correspondingLink) {
                correspondingLink.parentElement.classList.add('active');
            }
        }

        getHeadingId(heading) {
            return heading.id || 
                   heading.getAttribute('data-id') || 
                   heading.querySelector('[id]')?.id;
        }

        observeHeadings() {
            this.headings.forEach(heading => {
                if (this.getHeadingId(heading)) {
                    this.observer.observe(heading);
                }
            });
        }

        initializeClickHandlers() {
            this.tocLinks.forEach(link => {
                link.addEventListener('click', (e) => {
                    this.removeActiveClasses();
                    link.parentElement.classList.add('active');
                });
            });
        }

        checkInitialActiveHeading() {
            const viewportHeight = window.innerHeight;
            
            for (const heading of this.headings) {
                const rect = heading.getBoundingClientRect();
                if (rect.top >= 0 && rect.top <= viewportHeight * 0.5) {
                    this.removeActiveClasses();
                    this.activateCorrespondingLink(heading);
                    break;
                }
            }
        }
    }

    // Initialize the table of contents
    try {
        new TableOfContents();
    } catch (error) {
        console.error('Failed to initialize Table of Contents:', error);
    }
});


